"use client";

import { useSyncExternalStore } from "react";

type Returns = {
  isMobileScreen: boolean;
  isTabletScreen: boolean;
  isDesktopScreen: boolean;
  isWideScreen: boolean;
};

const MOBILE_MAX_WIDTH = 768;
const DESKTOP_MIN_WIDTH = 1200;
const WIDE_MIN_WIDTH = 1440;

const BREAKPOINT_QUERY_LIST = [
  `(min-width: ${MOBILE_MAX_WIDTH}px)`,
  `(min-width: ${DESKTOP_MIN_WIDTH}px)`,
  `(min-width: ${WIDE_MIN_WIDTH}px)`,
];

const subscribeBreakpoint = (onStoreChange: () => void) => {
  const mediaQueryList = BREAKPOINT_QUERY_LIST.map((query) =>
    window.matchMedia(query),
  );

  mediaQueryList.forEach((mediaQuery) =>
    mediaQuery.addEventListener("change", onStoreChange),
  );

  return () =>
    mediaQueryList.forEach((mediaQuery) =>
      mediaQuery.removeEventListener("change", onStoreChange),
    );
};

export const useCheckWindowSize = (): Returns => {
  const windowWidth = useSyncExternalStore(
    subscribeBreakpoint,
    () => window.innerWidth,
    () => DESKTOP_MIN_WIDTH,
  );

  return {
    isMobileScreen: windowWidth < MOBILE_MAX_WIDTH,
    isTabletScreen:
      windowWidth >= MOBILE_MAX_WIDTH && windowWidth < DESKTOP_MIN_WIDTH,
    isDesktopScreen: windowWidth >= DESKTOP_MIN_WIDTH,
    isWideScreen: windowWidth >= WIDE_MIN_WIDTH,
  };
};
